import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// Gelir Tablosu Bileşeni
const GelirTablosu = () => {
  return (
    <Box sx={{ mt: 3 }}>
      <Paper sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6">Gelir Tablosu</Typography>
          <Tooltip title="Gelir tablosu hakkında bilgi">
            <IconButton size="small">
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Paper>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="right">1.YIL</TableCell>
              <TableCell align="right">2.YIL</TableCell>
              <TableCell align="right">3.YIL</TableCell>
              <TableCell align="right">4.YIL</TableCell>
              <TableCell align="right">5.YIL</TableCell>
              <TableCell align="right">TOPLAM</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              { label: 'SATIŞ GELİRLERİ', values: [0, 0, 0, 0, 0, 0] },
              { label: 'ÖZ SERMAYE', values: [0, 0, 0, 0, 0, 0] },
              { label: 'FONLAMA GELİRİ', values: [0, 0, 0, 0, 0, 0] },
              { label: 'TOPLAM GİRİŞLER', values: [0, 0, 0, 0, 0, 0] },
            ].map((row) => (
              <TableRow key={row.label}>
                <TableCell>{row.label}</TableCell>
                {row.values.map((value, index) => (
                  <TableCell key={index} align="right">₺ {value.toLocaleString()}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

// Gider Tablosu Bileşeni
const GiderTablosu = () => {
  return (
    <Box sx={{ mt: 3 }}>
      <Paper sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6">Gider Tablosu</Typography>
          <Tooltip title="Gider tablosu hakkında bilgi">
            <IconButton size="small">
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Paper>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="right">1.YIL</TableCell>
              <TableCell align="right">2.YIL</TableCell>
              <TableCell align="right">3.YIL</TableCell>
              <TableCell align="right">4.YIL</TableCell>
              <TableCell align="right">5.YIL</TableCell>
              <TableCell align="right">TOPLAM</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              { label: 'YILLIK İŞLETME GİDERLERİ', values: [125234, 0, 0, 0, 0, 125234] },
              { label: 'YATIRIMLAR', values: [33432, 234234, 0, 0, 0, 267666] },
              { label: 'DOĞRUDAN SATIŞ MALİYETLERİ', values: [0, 0, 0, 0, 0, 0] },
              { label: 'TOPLAM ÇIKIŞLAR', values: [158666, 234234, 0, 0, 0, 392900] },
            ].map((row) => (
              <TableRow key={row.label}>
                <TableCell>{row.label}</TableCell>
                {row.values.map((value, index) => (
                  <TableCell key={index} align="right">₺ {value.toLocaleString()}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

// Nakit Akım Tablosu Bileşeni
const NakitAkimTablosu = () => {
  return (
    <Box sx={{ mt: 3 }}>
      <Paper sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6">Nakit Akım Tablosu</Typography>
          <Tooltip title="Nakit akım tablosu hakkında bilgi">
            <IconButton size="small">
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Paper>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="right">1.YIL</TableCell>
              <TableCell align="right">2.YIL</TableCell>
              <TableCell align="right">3.YIL</TableCell>
              <TableCell align="right">4.YIL</TableCell>
              <TableCell align="right">5.YIL</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              { label: 'TOPLAM NAKİT VARLIK', values: [0, -158666, -392900, -392900, -392900] },
              { label: 'TOPLAM GİRİŞLER', values: [0, 0, 0, 0, 0] },
              { label: 'TOPLAM ÇIKIŞLAR', values: [158666, 234234, 0, 0, 0] },
              { label: 'KÜMÜLATİF N.V. DEVİR', values: [-158666, -392900, -392900, -392900, -392900] },
            ].map((row) => (
              <TableRow key={row.label}>
                <TableCell>{row.label}</TableCell>
                {row.values.map((value, index) => (
                  <TableCell key={index} align="right">
                    {value < 0 ? '(' : ''}
                    ₺ {Math.abs(value).toLocaleString()}
                    {value < 0 ? ')' : ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

// Ana Sayfa Bileşeni
const FinancialCashFlow = () => {
  return (
    <Container maxWidth="xl">
      <GelirTablosu />
      <GiderTablosu />
      <NakitAkimTablosu />
    </Container>
  );
};

export default FinancialCashFlow;